import { FC, PropsWithChildren } from 'react';

import { getAdminPanelSession } from 'app/api/cookie';
import { useIsPayee } from 'app/api/hooks/core/v1/auth/user';

import PayeeBankAccountStatusCheck from './PayeeBankAccountStatusCheck';

const BankAccountStatusCheck: FC<PropsWithChildren> = props =>
  useIsPayee() && getAdminPanelSession() !== 'true'
    ? (
      <PayeeBankAccountStatusCheck>
        {props.children}
      </PayeeBankAccountStatusCheck>
    )
    : props.children;

export default BankAccountStatusCheck;
